export const clientId = ['modelsend.com', 'dcomments-prod.web.app', 'dcomments-prod.firebaseapp.com'].includes(window.location.host) ?
  process.env.REACT_APP_PROD_PAYPAL_CLIENT_ID :
  process.env.REACT_APP_DEV_PAYPAL_CLIENT_ID;